var React = require('react');

function SpeakerPlaying (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeWidth":"10"},[React.createElement("path",{"stroke":"#2F73A7","strokeLinejoin":"round","d":"M133 40L71 93H13v68h57l63 54z","key":0}),React.createElement("path",{"stroke":"#0D3B5E","strokeLinecap":"round","d":"M164 90c15 23 15 53 0 76m25-102c28 38 28 90 0 128m24-151c40 51 40 123 0 174","key":1})]));
}

SpeakerPlaying.defaultProps = {"viewBox":"0 0 256 256"};

module.exports = SpeakerPlaying;

SpeakerPlaying.default = SpeakerPlaying;
